export function getHijriDate(date?: Date): string {
  const targetDate = date || new Date();

  const localDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());

  const hijriMonths = [
    'Muharram', 'Safar', 'Rabi I', 'Rabi II', 'Jumada I', 'Jumada II',
    'Rajab', 'Sha\'ban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'
  ];

  const y = localDate.getFullYear();
  const m = localDate.getMonth() + 1;
  const d = localDate.getDate();

  let a = Math.floor((11 * y + 3) / 30);
  let b = Math.floor((y - 621) / 100);
  let jd = Math.floor((1461 * y) / 4) + Math.floor((153 * m + 2) / 5) + d + 1948440 + a - b + 1;

  let l = jd - 1948440 + 10632;
  let n = Math.floor((l - 1) / 10631);
  let l2 = l - 10631 * n + 354;
  let j = Math.floor((10985 - l2) / 5316) * Math.floor((50 * l2) / 17719) +
            Math.floor(l2 / 5670) * Math.floor((43 * l2) / 15238);
  let l3 = l2 - Math.floor((30 - j) / 15) * Math.floor((17719 * j) / 50) -
             Math.floor(j / 16) * Math.floor((15238 * j) / 43) + 29;
  let hijriMonth = Math.floor((24 * l3) / 709);
  let hijriDay = l3 - Math.floor((709 * hijriMonth) / 24);
  let hijriYear = 30 * n + j - 30;

  return `${hijriDay} ${hijriMonths[hijriMonth - 1]} ${hijriYear}`;
}

export function getHijriYear(date?: Date): number {
  const targetDate = date || new Date();
  const localDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());

  const y = localDate.getFullYear();
  const m = localDate.getMonth() + 1;
  const d = localDate.getDate();

  let a = Math.floor((11 * y + 3) / 30);
  let b = Math.floor((y - 621) / 100);
  let jd = Math.floor((1461 * y) / 4) + Math.floor((153 * m + 2) / 5) + d + 1948440 + a - b + 1;

  let l = jd - 1948440 + 10632;
  let n = Math.floor((l - 1) / 10631);
  let l2 = l - 10631 * n + 354;
  let j = Math.floor((10985 - l2) / 5316) * Math.floor((50 * l2) / 17719) +
            Math.floor(l2 / 5670) * Math.floor((43 * l2) / 15238);

  return 30 * n + j - 30;
}
